module.exports = __webpack_public_path__ + "static/assets/61e8c22b4924dc71d45143ecda9c9a57.png";